import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataListModel, ApplicationRouteURL, WeGoAuthorizedLink, Permission, PermissionType, RoleLevel } from './../../shared/config';
import { SignupFormConfigService } from "../models/signupfromconfig.service";
import { SignupFormConfigModel } from "../models/signupformconfig.model";


@Component({
  selector: 'wego-signupConfig-list',
  template: require('../views/signupformconfig-list.component.html'),
  providers: [SignupFormConfigService],
  styles: [
    `
      .truncate-event-data{
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `
  ]
})
export class SignupFormConfigListComponent implements OnInit {
  DataListModel: DataListModel;
  signupConfigList: SignupFormConfigModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  urlsignupformconfigUpdatePage: string;
  isParentCheck: boolean;
  deleteSignupFormConfigHashId: string;
  errorMessage: string;
  isMultipleDelete: boolean;
  deleteMessage: string;
  urlSignupFormConfigList: string;
  signupUrl: string;
  addSignUpFormLink: any;
  urlsignupformconfigAddPage: string;
  roleLevel = RoleLevel;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('childModal') public childModal: any;
  private popupMsg: string;
  private module: string;

  get isAnyChecked(): boolean {
    if (this.signupConfigList) {
      let isCheck = this.signupConfigList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.signupConfigList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private signupFormConfigService: SignupFormConfigService,
    private translateService: TranslateService,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.signupUrl = window.location.origin + "/#/signup/";
    this.module = this.translateService.instant('LblSignUpForm');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance){
      this.DataListModel.searchField = ["instanceName", "organizationName", "title", "description"];
    }else{
      this.DataListModel.searchField = ["organizationName", "title", "description"];
    }
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlsignupformconfigUpdatePage = this.authService.GetURL(ApplicationRouteURL.URL_SIGNUPFORM_UPDATE);
    this.urlsignupformconfigAddPage = this.authService.GetURL(ApplicationRouteURL.URL_SIGNUPFORM_ADD);

    this.addSignUpFormLink = new WeGoAuthorizedLink(this.urlsignupformconfigAddPage,
      Permission.PR_SIGNUP_FORMS_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');

    this.GetTemplateList();
  }

  get isDeleteAccess(): boolean {
    if (this.signupConfigList) {
      return this.signupConfigList.some(x => x.isDeletable);
    }
    else { return false; }
  }

  public GetTemplateList() {
    this.isLoading = true;

    this.signupFormConfigService.GetSignupFormList(this.DataListModel)
      .subscribe(
      res => {
        this.signupConfigList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetTemplateList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetTemplateList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetTemplateList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetTemplateList();
  };

  public OnParentCheck(isChecked: boolean) {
    this.signupConfigList.filter(x => x.isDeletable).forEach(x => x.isChecked = (isChecked && x.instanceHashId ? true : false));
  }

  public ShowChildModal(templateHashId?: string): void {
    if (templateHashId) {
      this.popupMsg = this.translateService.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteSignupFormConfigHashId = templateHashId;
    }
    else {
      this.popupMsg = this.translateService.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.deleteSignupFormConfigHashId = "";
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deletedSignupFormList: any[];
    if (this.isMultipleDelete)
      deletedSignupFormList = this.signupConfigList.filter(x => x.isChecked).map(x => x.signupFormConfigHashId);
    else
      deletedSignupFormList.push(this.deleteSignupFormConfigHashId);

    this.DeleteSignupConfig(deletedSignupFormList);
    this.childModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public DeleteSignupConfig(deletedSignupFormList: string[]) {
    this.isLoading = true;
    this.signupFormConfigService.DeleteSignupFormConfig(deletedSignupFormList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetTemplateList();
        this.popupMsg = this.translateService.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.signupFormConfigService.ExportSignupConfigList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SignupFormConfig" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/components/signupformconfig-list.component.ts